/* tcp-share-meta.js — seed + update share image/meta only on the builder page */
(function () {
  function ready(fn){ document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }

  function ensureHeadMeta(sel, kv){
    let el = document.head.querySelector(sel);
    if (!el){ el = document.createElement('meta'); for (const [k,v] of Object.entries(kv)) el.setAttribute(k,v); document.head.appendChild(el); }
    return el;
  }
  function ensureHeadLink(sel, rel){
    let el = document.head.querySelector(sel);
    if (!el){ el = document.createElement('link'); el.setAttribute('rel', rel); document.head.appendChild(el); }
    return el;
  }

  ready(function(){
    // Only run if the builder exists on this page
    const root = document.getElementById('tcp-animals-builder');
    if (!root) return;

    // Seed once (no duplicates): OG, Twitter, schema, legacy link
    const ogImg   = ensureHeadMeta('meta[property="og:image"]',             { property:'og:image' });
    const ogImgS  = ensureHeadMeta('meta[property="og:image:secure_url"]',  { property:'og:image:secure_url' });
    const ogW     = ensureHeadMeta('meta[property="og:image:width"]',       { property:'og:image:width' });
    const ogH     = ensureHeadMeta('meta[property="og:image:height"]',      { property:'og:image:height' });
    const twCard  = ensureHeadMeta('meta[name="twitter:card"]',             { name:'twitter:card' });
    const twImg   = ensureHeadMeta('meta[name="twitter:image"]',            { name:'twitter:image' });
    const itemImg = ensureHeadMeta('meta[itemprop="image"]',                { itemprop:'image' });
    const linkImg = ensureHeadLink('link[rel="image_src"]',                 'image_src');
    twCard.setAttribute('content', 'summary_large_image');
    // Encourage big previews
    ensureHeadMeta('meta[name="robots"]', { name:'robots' }).setAttribute('content','max-image-preview:large');

    // Discoverable but invisible <img> (many scrapers look for a real image element)
    let shareImg = document.getElementById('tcp-share-img');
    if (!shareImg){
      shareImg = document.createElement('img');
      shareImg.id  = 'tcp-share-img';
      shareImg.alt = '';
      shareImg.setAttribute('aria-hidden','true');
      shareImg.style.cssText = 'position:absolute;left:-10000px;top:0;width:0;height:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);';
      document.body.appendChild(shareImg);
    }

    // Public setter other scripts can call (animals-builder already computes the URL)
    window.tcpSetShareMeta = function(url, w, h){
      if (!url) return;
      const abs = url.startsWith('http') ? url : new URL(url, location.origin).href;
      ogImg.setAttribute('content', abs);
      ogImgS.setAttribute('content', abs);
      twImg.setAttribute('content', abs);
      itemImg.setAttribute('content', abs);
      linkImg.setAttribute('href', abs);
      if (w) ogW.setAttribute('content', String(w));
      if (h) ogH.setAttribute('content', String(h));

      // Make sure a real <img> with that URL exists (some parsers prefer this)
      const bust = abs + (abs.includes('?') ? '&' : '?') + 'v=' + Date.now();
      shareImg.removeAttribute('width'); shareImg.removeAttribute('height');
      shareImg.style.width = (w || 1200) + 'px'; // “large” signal
      shareImg.style.height = 'auto';
      shareImg.src = bust;
    };

    // Optional: if another script fires this event, we’ll update automatically.
    window.addEventListener('tcp-share-image', (ev)=>{
      const d = ev.detail || {};
      window.tcpSetShareMeta(d.url, d.w, d.h);
    });
  });
})();